// extracted by mini-css-extract-plugin
export default {"privacyDrawerContent":"page_privacyDrawerContent__oZh5g"};